module.exports = __webpack_public_path__ + "static/media/detail_page_view.fd076497.svg";